import { useEffect, useState } from "react";
import { API } from "../lib/api";

export default function ProfileAvatar({ user, small = false, large = false, preview }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [user?.photo_updated_at, preview]);
  const photo = preview || (user?.has_profile_photo && !failed ? `${API}/auth/profile/photo?v=${encodeURIComponent(user.photo_updated_at || "latest")}` : "");
  const initials = (user?.name || "?").trim().split(/\s+/).map(part => part[0]).join("").slice(0, 2).toUpperCase();
  return <div className={`avatar${small ? " small" : ""}${large ? " profile-avatar-large" : ""}${photo ? " has-photo" : ""}`} aria-label={`Foto profil ${user?.name || "pengguna"}`}>
    {photo ? <img src={photo} crossOrigin={preview ? undefined : "use-credentials"} alt="" onError={() => setFailed(true)} /> : initials}
  </div>;
}
